<template>
  <ul
    class="scrollText page_text_font"
    :class="{
      'scrollText--show-xs': list && showRule === 'showXs',
      'scrollText--show-lg': list && showRule === 'showLg',
      'scrollText--show-md': list && showRule === 'showMd',
      'scrollText_none': !allHasTextList||allHasTextList==[]||allHasTextList.length==0,
    }"
  >
    <li
      v-for="(item, index) in allHasTextList"
      :key="item.text + index"
      class="menu_icon_color vogue_menu_icon_color"
      @mouseenter.stop="mouseenter"
      @mouseleave.stop="mouseleave"
      :class="{ active: index == current }"
    >
      {{ item.text }}
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      require: true,
    },
    time: {
      type: Number,
      default: 4,
    },
    mbstyle: {
      default: false,
    },
    showRule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      current: 0,
      timer: null,
    };
  },
  methods: {
    mouseenter() {
      clearInterval(this.timer);
    },
    mouseleave() {
      this.setTime();
    },
    setTime() {
      if (!this.allHasTextList || !this.allHasTextList.length || this.allHasTextList.length < 2) return;
      this.timer = setInterval(() => {
        if (this.current < this.allHasTextList.length - 1) this.current++;
        else this.current = 0;
      }, this.time * 1000);
    },
  },
  computed: {
    allHasTextList() {
      let allList = []
      if(!this.list || this.list==[]) return allList
      for(let item of this.list) {
        if(item.text && item.text!='') {
          allList.push(item)
        }
      }
      return allList
    }
  },
  mounted() {
    this.setTime();
  },
};
</script>
<style scoped lang='scss'>
.scrollText_none {
   height: 0px !important;  
}
.scrollText {
  font-size: 14px;
  margin: 0;
  position: relative;
  padding: 0 15px;
  max-width: 100%;
  line-height: 1.6;
  li {
    white-space: nowrap;
    list-style: none;
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .active {
    position: relative;
    opacity: 1;
    transition: all 1s;
    height: auto;
  }
  &--show-md,
  &--show-xs {
    display: none;
  }
  &--show-lg {
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 1024px) {
    height: 44px;
    line-height: 44px;
    &--show-lg,
    &--show-xs {
      display: none;
    }
    &--show-md {
      display: block;
        li {
          padding-left: 15px;
          width: 100vw;
       }
    }
  }
  @media screen and (max-width: 767px) {
    &--show-md,
    &--show-lg {
      display: none;
    }
    &--show-xs {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      .scrollText {
         li {
          padding-left: 15px;
        }
      }
    }
  }
}
</style>